// Path constants for the orders module. Centralised so a backend route
// rename is a one-file change.

import apiEndpoints from '@core/config/apiEndpoints'

export const ORDERS_ENDPOINT_PATHS = {
  /** Listing + creation root. */
  LIST: apiEndpoints.ORDERS,
  /** Resource detail. Use `detail(id)`. */
  DETAIL: (id: string) => `${apiEndpoints.ORDERS}/${id}`,
  /** Reject an order. Use `reject(id)`. */
  REJECT: (id: string) => `${apiEndpoints.ORDERS}/${id}/reject`,
  /** Cancel an order on the investor's behalf. Use `cancel(id)`. */
  CANCEL: (id: string) => `${apiEndpoints.ORDERS}/${id}/cancel`,
  /** Approve an order. Use `approve(id)`. */
  APPROVE: (id: string) => `${apiEndpoints.ORDERS}/${id}/approve`,
  /** Register the order with the VASP provider (POST). */
  VASP_ORDER: (id: string) => `${apiEndpoints.ORDERS}/${id}/vasp-order`,
  /** Pull the live vendor status and reconcile it locally (POST). */
  VASP_ORDER_SYNC: (id: string) => `${apiEndpoints.ORDERS}/${id}/vasp-order/sync`,
  /** Finalise a fully funded order — completes the offering (PATCH). */
  FINALISE: (id: string) => `${apiEndpoints.ORDERS}/${id}/finalise`,
  /** Per-status rollup behind the sidebar's VAISP processing badge (GET). */
  VASP_STATUS_COUNTS: `${apiEndpoints.ORDERS}/vasp-status-counts`,
  /**
   * How many of an offering's orders are ready for token issuance (GET).
   * Informational only — it gates nothing. See `vaspListingReadiness.ts`.
   */
  OFFERING_VASP_LISTING_READINESS: (offeringId: string) =>
    `${apiEndpoints.ORDERS}/offerings/${offeringId}/vasp-listing-readiness`,
  // Every order on one offering, for the offering detail drawer. Under orders
  // because it IS an order list; the offering is only the filter.
  OFFERING_ORDERS: (offeringId: string) => `${apiEndpoints.ORDERS}/offerings/${offeringId}/orders`,
  // LST-08. Lives under orders, not offerings, because the unwind IS order-side
  // work — it cancels every order, returns their capacity and raises the refunds.
  CANCEL_REJECTED_LISTING: (offeringId: string) =>
    `${apiEndpoints.ORDERS}/offerings/${offeringId}/cancel-rejected-listing`,
} as const
